import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

import { useDispatch } from "react-redux";
import { setNavigate } from "store/Auth/actions";

const Authmiddleware = ({
	component: Component,
	layout: Layout,
	routePrefix: routePrefix,
	isAuthProtected,
	panel,
	path,
	setType,
	...rest
}) => {
	const pathName = rest?.location?.pathname;
	const dispatch = useDispatch();

	useEffect(() => {
		if (panel === "user") {
			setType(panel);
		}
	}, [panel]);

	return (
		<Route
			{...rest}
			render={(props) => {
				if (isAuthProtected && !localStorage.getItem("token")) {
					if (panel === "user") {
						if (!!pathName) {
							dispatch(setNavigate(pathName));
						}
						return (
							<Redirect
								to={{
									pathname: "/",
								}}
							/>
						);
					} else if (panel === "provider") {
						if (!!pathName.split("/sales-rep/")[1] !== "login") {
							dispatch(setNavigate(pathName.split("/sales-rep/")[1]));
						}
						return (
							<Redirect
								to={{
									pathname: "/sales-rep/login",
									state: { from: props.location },
								}}
							/>
						);
					} else if (panel === "admin") {
						if (!!pathName.split("/admin/")[1] !== "login") {
							dispatch(setNavigate(pathName.split("/admin/")[1]));
						}
						return (
							<Redirect
								to={{
									pathname: "/admin/login",
									state: { from: props.location },
								}}
							/>
						);
					} else if (panel === "sales-developer") {
						if (!!pathName.split("/sales-developer/")[1] !== "login") {
							dispatch(setNavigate(pathName.split("/sales-developer/")[1]));
						}
						return (
							<Redirect
								to={{
									pathname: "/sales-developer/login",
									state: { from: props.location },
								}}
							/>
						);
					}
				} else if (isAuthProtected && localStorage.getItem("token")) {
					return (
						<Layout routePrefix={routePrefix}>
							<Component {...props} />
						</Layout>
					);
				} else {
					return (
						<Layout routePrefix={routePrefix}>
							<Component {...props} />
						</Layout>
					);
				}
			}}
		/>
	);
};

Authmiddleware.propTypes = {
	isAuthProtected: PropTypes.bool,
	component: PropTypes.any,
	location: PropTypes.object,
	layout: PropTypes.any,
};

export default Authmiddleware;
